import React, { useState, useEffect, useRef } from 'react';
import './ModalContenidoCurso.css';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/curso_detalle.php';

/* ── Icons ── */
const IconPlus    = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconTrash   = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="3 6 5 6 21 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M10 11v6M14 11v6M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconEdit    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCheck   = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconClose   = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconUpload  = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><polyline points="17 8 12 3 7 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconDrag    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><circle cx="9" cy="6" r="1.5" fill="currentColor"/><circle cx="15" cy="6" r="1.5" fill="currentColor"/><circle cx="9" cy="12" r="1.5" fill="currentColor"/><circle cx="15" cy="12" r="1.5" fill="currentColor"/><circle cx="9" cy="18" r="1.5" fill="currentColor"/><circle cx="15" cy="18" r="1.5" fill="currentColor"/></svg>);
const IconSpinner = () => (<span className="mcc-spinner"/>);

const TIPO_ICON = { pdf:'📄', word:'📝', ppt:'📊', excel:'📈', zip:'📦', video:'🎥', imagen:'🖼', otro:'📎' };
const TIPO_COLOR = { pdf:'#e53e3e', word:'#2563eb', ppt:'#d97706', excel:'#16a34a', zip:'#7c3aed', video:'#db2777', imagen:'#0891b2', otro:'#5a6a63' };

export default function ModalContenidoCurso({ moodleId, onToast }) {
  const [tab,        setTab]        = useState('descripcion'); // descripcion | temario | instructor | materiales
  const [cargando,   setCargando]   = useState(true);
  const [guardando,  setGuardando]  = useState(false);

  // Descripción
  const [descripcion, setDescripcion] = useState('');

  // Temario: [{ modulo: '', temas: [''] }]
  const [temario, setTemario] = useState([]);

  // Instructor
  const [instructor, setInstructor] = useState({ nombre:'', cargo:'', bio:'', foto:'' });

  // Materiales
  const [materiales,  setMateriales]  = useState([]);
  const [subiendo,    setSubiendo]    = useState(false);
  const [progresoSub, setProgresoSub] = useState(0);
  const [nuevoMat,    setNuevoMat]    = useState({ nombre:'', descripcion:'' });
  const [editMat,     setEditMat]     = useState(null); // { id, nombre, descripcion }
  const fileRef = useRef();

  /* ── Cargar datos ── */
  useEffect(() => {
    if (!moodleId) return;
    setCargando(true);
    fetch(`${API}?action=get&moodle_id=${moodleId}`)
      .then(r => r.json())
      .then(j => {
        if (!j.success) return;
        const d = j.data?.detalle;
        const m = j.data?.materiales || [];
        if (d) {
          setDescripcion(d.descripcion || '');
          setTemario(d.temario && d.temario.length ? d.temario : []);
          setInstructor({
            nombre: d.instructor_nombre || '',
            cargo:  d.instructor_cargo  || '',
            bio:    d.instructor_bio    || '',
            foto:   d.instructor_foto   || '',
          });
        }
        setMateriales(m);
      })
      .catch(() => {})
      .finally(() => setCargando(false));
  }, [moodleId]);

  /* ── Guardar descripción + temario + instructor ── */
  const guardar = async () => {
    setGuardando(true);
    try {
      const r = await fetch(`${API}?action=guardar_detalle`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({
          moodle_id:         moodleId,
          descripcion:       descripcion,
          temario:           temario,
          instructor_nombre: instructor.nombre,
          instructor_cargo:  instructor.cargo,
          instructor_bio:    instructor.bio,
          instructor_foto:   instructor.foto,
        }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      onToast('Contenido guardado correctamente');
    } catch(err) { onToast(err.message, 'error'); }
    finally { setGuardando(false); }
  };

  /* ── Subir material ── */
  const subirMaterial = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!nuevoMat.nombre.trim()) { onToast('Ingresa un nombre para el material', 'error'); return; }

    const formData = new FormData();
    formData.append('archivo',     file);
    formData.append('moodle_id',   moodleId);
    formData.append('nombre',      nuevoMat.nombre);
    formData.append('descripcion', nuevoMat.descripcion);

    setSubiendo(true);
    setProgresoSub(0);

    // Simular progreso
    const interval = setInterval(() => setProgresoSub(p => Math.min(p + 15, 85)), 300);

    try {
      const r = await fetch(`${API}?action=subir_material`, { method:'POST', body: formData });
      clearInterval(interval);
      setProgresoSub(100);
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setMateriales(m => [...m, j.data]);
      setNuevoMat({ nombre:'', descripcion:'' });
      onToast('Material subido correctamente');
    } catch(err) {
      clearInterval(interval);
      onToast(err.message || 'Error al subir el archivo', 'error');
    } finally {
      setSubiendo(false);
      setProgresoSub(0);
      if (fileRef.current) fileRef.current.value = '';
    }
  };

  /* ── Eliminar material ── */
  const eliminarMaterial = async (id) => {
    if (!window.confirm('¿Eliminar este material?')) return;
    try {
      const r = await fetch(`${API}?action=eliminar_material`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify({ id }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setMateriales(m => m.filter(mat => mat.id !== id));
      onToast('Material eliminado');
    } catch(err) { onToast(err.message, 'error'); }
  };

  /* ── Guardar edición de material ── */
  const guardarEditMat = async () => {
    if (!editMat?.nombre?.trim()) { onToast('El nombre es obligatorio', 'error'); return; }
    try {
      const r = await fetch(`${API}?action=editar_material`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify(editMat),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setMateriales(m => m.map(mat => mat.id===editMat.id ? {...mat, nombre:editMat.nombre, descripcion:editMat.descripcion} : mat));
      setEditMat(null);
      onToast('Material actualizado');
    } catch(err) { onToast(err.message, 'error'); }
  };

  /* ── Temario helpers ── */
  const agregarModulo = () => setTemario(t => [...t, { modulo:'', temas:[''] }]);
  const quitarModulo  = i  => setTemario(t => t.filter((_,idx) => idx!==i));
  const setModulo     = (i, val) => setTemario(t => t.map((m,idx) => idx===i ? {...m, modulo:val} : m));
  const agregarTema   = i  => setTemario(t => t.map((m,idx) => idx===i ? {...m, temas:[...m.temas,'']} : m));
  const quitarTema    = (mi, ti) => setTemario(t => t.map((m,idx) => idx===mi ? {...m, temas:m.temas.filter((_,tidx)=>tidx!==ti)} : m));
  const setTema       = (mi, ti, val) => setTemario(t => t.map((m,idx) => idx===mi ? {...m, temas:m.temas.map((te,tidx)=>tidx===ti?val:te)} : m));

  if (cargando) return (
    <div className="mcc-loading"><IconSpinner/> Cargando contenido…</div>
  );

  return (
    <div className="mcc-wrap">

      {/* Tabs internos */}
      <div className="mcc-tabs">
        {[
          { id:'descripcion', label:'📝 Descripción' },
          { id:'temario',     label:'📋 Temario'     },
          { id:'instructor',  label:'👤 Instructor'  },
          { id:'materiales',  label:'📁 Materiales'  },
        ].map(t => (
          <button key={t.id}
            className={`mcc-tab ${tab===t.id?'mcc-tab--active':''}`}
            onClick={()=>setTab(t.id)}
          >{t.label}</button>
        ))}
      </div>

      {/* ── DESCRIPCIÓN ── */}
      {tab === 'descripcion' && (
        <div className="mcc-section">
          <p className="mcc-hint">Descripción detallada que aparecerá en la página del curso. Soporta saltos de línea.</p>
          <textarea
            className="mcc-textarea mcc-textarea--tall"
            placeholder="Escribe una descripción detallada del curso, objetivos, a quién va dirigido…"
            value={descripcion}
            onChange={e=>setDescripcion(e.target.value)}
          />
          <button className="mcc-btn-save" onClick={guardar} disabled={guardando}>
            {guardando?<><IconSpinner/> Guardando…</>:<><IconCheck/> Guardar descripción</>}
          </button>
        </div>
      )}

      {/* ── TEMARIO ── */}
      {tab === 'temario' && (
        <div className="mcc-section">
          <p className="mcc-hint">Organiza el contenido en módulos con sus temas.</p>

          {temario.length === 0 && (
            <div className="mcc-empty-hint">No hay módulos. Agrega el primero.</div>
          )}

          {temario.map((mod, mi) => (
            <div className="mcc-modulo" key={mi}>
              <div className="mcc-modulo__head">
                <input
                  type="text"
                  className="mcc-input mcc-input--modulo"
                  placeholder={`Módulo ${mi+1}: Ej. Fundamentos`}
                  value={mod.modulo}
                  onChange={e=>setModulo(mi, e.target.value)}
                />
                <button className="mcc-icon-btn mcc-icon-btn--del" onClick={()=>quitarModulo(mi)} title="Eliminar módulo">
                  <IconTrash/>
                </button>
              </div>
              <div className="mcc-temas">
                {mod.temas.map((tema, ti) => (
                  <div className="mcc-tema-row" key={ti}>
                    <span className="mcc-tema-num">{ti+1}</span>
                    <input
                      type="text"
                      className="mcc-input"
                      placeholder="Nombre del tema…"
                      value={tema}
                      onChange={e=>setTema(mi, ti, e.target.value)}
                    />
                    <button className="mcc-icon-btn mcc-icon-btn--del-sm" onClick={()=>quitarTema(mi, ti)} title="Quitar tema">
                      <IconClose/>
                    </button>
                  </div>
                ))}
                <button className="mcc-btn-add-tema" onClick={()=>agregarTema(mi)}>
                  <IconPlus/> Agregar tema
                </button>
              </div>
            </div>
          ))}

          <button className="mcc-btn-add-modulo" onClick={agregarModulo}>
            <IconPlus/> Agregar módulo
          </button>

          <button className="mcc-btn-save" onClick={guardar} disabled={guardando}>
            {guardando?<><IconSpinner/> Guardando…</>:<><IconCheck/> Guardar temario</>}
          </button>
        </div>
      )}

      {/* ── INSTRUCTOR ── */}
      {tab === 'instructor' && (
        <div className="mcc-section">
          <p className="mcc-hint">Datos del instructor que aparecerán en la página del curso.</p>
          <div className="mcc-instructor-grid">
            <div className="mcc-field">
              <label>Nombre completo</label>
              <input type="text" className="mcc-input" placeholder="Ej: Mg. Ana García"
                value={instructor.nombre} onChange={e=>setInstructor(i=>({...i,nombre:e.target.value}))}/>
            </div>
            <div className="mcc-field">
              <label>Cargo / Especialidad</label>
              <input type="text" className="mcc-input" placeholder="Ej: Especialista en Lenguaje"
                value={instructor.cargo} onChange={e=>setInstructor(i=>({...i,cargo:e.target.value}))}/>
            </div>
            <div className="mcc-field mcc-field--full">
              <label>Biografía</label>
              <textarea className="mcc-textarea" rows="4" placeholder="Breve biografía del instructor…"
                value={instructor.bio} onChange={e=>setInstructor(i=>({...i,bio:e.target.value}))}/>
            </div>
            <div className="mcc-field mcc-field--full">
              <label>URL de foto</label>
              <input type="url" className="mcc-input" placeholder="https://… (URL de imagen del instructor)"
                value={instructor.foto} onChange={e=>setInstructor(i=>({...i,foto:e.target.value}))}/>
              {instructor.foto && (
                <img src={instructor.foto} alt="Preview" className="mcc-foto-preview"
                  onError={e=>e.target.style.display='none'}/>
              )}
            </div>
          </div>
          <button className="mcc-btn-save" onClick={guardar} disabled={guardando}>
            {guardando?<><IconSpinner/> Guardando…</>:<><IconCheck/> Guardar instructor</>}
          </button>
        </div>
      )}

      {/* ── MATERIALES ── */}
      {tab === 'materiales' && (
        <div className="mcc-section">

          {/* Formulario subir */}
          <div className="mcc-upload-box">
            <h4>Subir nuevo material</h4>
            <div className="mcc-upload-form">
              <div className="mcc-field">
                <label>Nombre del material *</label>
                <input type="text" className="mcc-input" placeholder="Ej: Guía de ejercicios — Módulo 1"
                  value={nuevoMat.nombre} onChange={e=>setNuevoMat(m=>({...m,nombre:e.target.value}))}/>
              </div>
              <div className="mcc-field">
                <label>Descripción (opcional)</label>
                <input type="text" className="mcc-input" placeholder="Breve descripción del archivo…"
                  value={nuevoMat.descripcion} onChange={e=>setNuevoMat(m=>({...m,descripcion:e.target.value}))}/>
              </div>
            </div>

            <label className={`mcc-upload-btn ${subiendo?'mcc-upload-btn--loading':''}`}>
              {subiendo ? (
                <>
                  <IconSpinner/>
                  <span>Subiendo… {progresoSub}%</span>
                  <div className="mcc-progress"><div className="mcc-progress__fill" style={{width:`${progresoSub}%`}}/></div>
                </>
              ) : (
                <><IconUpload/> Seleccionar archivo</>
              )}
              <input ref={fileRef} type="file" style={{display:'none'}}
                accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.zip,.rar,.mp4,.png,.jpg,.jpeg"
                onChange={subirMaterial} disabled={subiendo}/>
            </label>
            <p className="mcc-upload-hint">PDF, Word, PPT, Excel, ZIP, MP4, Imágenes · Máx. 50MB</p>
          </div>

          {/* Lista materiales */}
          {materiales.length === 0 ? (
            <div className="mcc-empty-hint">Aún no hay materiales subidos para este curso.</div>
          ) : (
            <div className="mcc-materiales-lista">
              <h4>Materiales subidos ({materiales.length})</h4>
              {materiales.map(mat => (
                <div className="mcc-mat-item" key={mat.id}>
                  {editMat?.id === mat.id ? (
                    /* Modo edición */
                    <div className="mcc-mat-edit">
                      <input type="text" className="mcc-input" value={editMat.nombre}
                        onChange={e=>setEditMat(m=>({...m,nombre:e.target.value}))}/>
                      <input type="text" className="mcc-input" placeholder="Descripción…" value={editMat.descripcion||''}
                        onChange={e=>setEditMat(m=>({...m,descripcion:e.target.value}))}/>
                      <div className="mcc-mat-edit__btns">
                        <button className="mcc-btn-save-sm" onClick={guardarEditMat}><IconCheck/> Guardar</button>
                        <button className="mcc-btn-cancel-sm" onClick={()=>setEditMat(null)}><IconClose/> Cancelar</button>
                      </div>
                    </div>
                  ) : (
                    /* Vista normal */
                    <>
                      <div className="mcc-mat-icon" style={{color: TIPO_COLOR[mat.tipo]||'#5a6a63'}}>
                        {TIPO_ICON[mat.tipo]||'📎'}
                      </div>
                      <div className="mcc-mat-info">
                        <strong>{mat.nombre}</strong>
                        {mat.descripcion && <span>{mat.descripcion}</span>}
                        <div className="mcc-mat-meta">
                          <span className="mcc-mat-tipo">{mat.tipo?.toUpperCase()}</span>
                          {mat.tamano_kb && <span>{mat.tamano_kb > 1024 ? `${(mat.tamano_kb/1024).toFixed(1)} MB` : `${mat.tamano_kb} KB`}</span>}
                          <a href={mat.archivo_url} target="_blank" rel="noopener noreferrer" className="mcc-mat-link">Ver archivo ↗</a>
                        </div>
                      </div>
                      <div className="mcc-mat-acciones">
                        <button className="mcc-icon-btn mcc-icon-btn--edit"
                          onClick={()=>setEditMat({id:mat.id,nombre:mat.nombre,descripcion:mat.descripcion||''})}
                          title="Editar">
                          <IconEdit/>
                        </button>
                        <button className="mcc-icon-btn mcc-icon-btn--del"
                          onClick={()=>eliminarMaterial(mat.id)}
                          title="Eliminar">
                          <IconTrash/>
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

    </div>
  );
}